import MathExt from "../../math.js"

ALLOWED_CONTROLLER = 'reports'
ALLOWED_ACTIONS = ['location_details']

class Statistic
  constructor: (controller, element) ->
    @controller = controller
    @element = $(element)
    @element.html('W')
    @name = @element.data('name')

  get_value: (name) =>
    el = @element.closest('tr').find('.statistic[data-name=' + name + ']')
    return parseInt(el.html())

  handle_error: (data, text_status, error_thrown) =>
    @element.html('<span class="error">E</span>')
    message = ''
    if text_status != 'error'
      message = text_status
    else if error_thrown != ''
      message = error_thrown
    else
      message = 'Unknown error, probably a network connection issue'
    console.error(data)
    console.error(text_status)
    console.error(error_thrown)
    current_flash = $('#flash').html()
    $('#flash').html(current_flash + '<div class="error">' + message + '</div>')
    @controller.load_next_statistic()

  handle_result: (data, text_status, jq_xhr) =>
    value = data['value']
    if @name == 'total_revenue'
      value = MathExt.round_to(value, 2)
    @element.html(value)
    @controller.load_next_statistic()

  load: () =>
    @element.addClass('loading')
    @element.html('<div class="ajax-status"></div>')
    if @name == 'total_rentals'
      @total_rentals()
      return
    if @name == 'unique_card_usages_per_space'
      @unique_card_usages_per_space()
      return

    $.ajax({
      method: 'GET',
      url: @element.data('url')
    }).done(@handle_result).fail(@handle_error)

  total_rentals: () =>
    weekday_rentals = @get_value('weekday_rentals')
    weekend_rentals = @get_value('weekend_rentals')
    @element.html(weekday_rentals + weekend_rentals)
    @controller.load_next_statistic()

  unique_card_usages_per_space: () =>
    unique_card_usages = @get_value('unique_card_usages')
    average_spaces_reporting = @get_value('average_spaces_reporting')
    value = 0
    if average_spaces_reporting > 0
      value = MathExt.round_to(unique_card_usages / average_spaces_reporting, 2)
    @element.html(value)
    @controller.load_next_statistic()

class ReportsController
  constructor: () ->
    @csv_only_report_names = [
      "Card Holders (CSV only)",
      "Daily Status (CSV only)",
      "User History (CSV only)",
      "Problem Reports (CSV only)",
    ]
    statistic_elements = $(".statistic")
    @statistics = []
    for statistic_element in statistic_elements
      statistic = new Statistic(this, statistic_element)
      @statistics.push(statistic)

  init_graphs: () =>
    $('*[data-selector="report_type"]').on 'change', @load_graphs
    $('*[data-selector="rental_reports"]').on 'change', @load_graphs()
    @load_graphs()

  load_graphs: () =>
    select = $('#report_type')
    select_1 = $('#rental_reports')
    report_name = select.val()
    $('#report_name').val(report_name)

    if report_name == "User Growth"
      $('*[data-selector="postal_codes"]').show("slowly")
    else
      $('*[data-selector="postal_codes"]').hide("slowly")
      $('*[data-selector="postal_codes"] input').val("")

    if report_name == "Peak Occupancy Distribution" || report_name == "Hourly Parked" || report_name == "Rental Starts"
      $('*[data-selector="report_weekend"]').show("slowly")
    else
      $('*[data-selector="report_weekend"]').hide("slowly")

    if report_name == "Rental Starts"
      $('*[data-selector="rental_reports"]').show("slowly")
    else
      $('*[data-selector="rental_reports"]').hide("slowly")

    $('.graph').each (index, element) ->
      $(element).data('json_url', $(element).data('url')+'&report='+report_name)
    $('a[data-selector="csv_link"]').each (index, element) ->
      $(element).attr('href', $(element).data('url')+'&report='+report_name)

    if select.find(':selected').attr("data-details_url") || select_1.find(':selected').attr("data-details_url")
      $('a[data-selector="details_link"]').each (index, element) ->
        $(element).attr('href', $(element).data('url')+'&report='+report_name)
    else
      $('a[data-selector="details_link"]').each (index, element) ->
    if select.find(':selected').attr('data-has_details')
      $('#csv_details_tag').attr('class', '')
    else
      $('#csv_details_tag').attr('class', 'hidden-by-css')
    notes = select.find(':selected').attr('data-notes')
    if notes == undefined
      notes = ''
    $('#notes').html(notes)

    count = $('.graph').length
    graphs = $('.graph')
    if @csv_only_report_names.indexOf(report_name) > -1
      for graph in graphs
        $(graph).html('')
        $(graph).addClass('graph-empty')
      return
    else
      for graphEmpty in $('.graph-empty')
        $(graphEmpty).removeClass('graph-empty')
    for graph in graphs
      $(graph).html('<div class="ajax-status">... waiting ...</div>')

    PlotlyGraph.start_graph(graphs, 0)

  load_next_statistic: () =>
    if @statistics.length > 0
      statistic = @statistics.shift()
      statistic.load()
    else
      @init_graphs()

ready = ->
  return unless continueIfAllowed(ALLOWED_CONTROLLER, ALLOWED_ACTIONS) || !!document.querySelector('turbo-frame#location_details_report')
  controller = new ReportsController()
  controller.load_next_statistic()

$(document).ready(ready)
$(document).on('turbo:frame-render', ready)
